import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "actions-list" }


export default /*@__PURE__*/_defineComponent({
  __name: 'QuickActions',
  emits: ['refresh'],
  setup(__props) {

/* eslint-disable no-undef */


return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("Quick Actions", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_router_link, {
              to: "/requests",
              class: "action-button"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createElementVNode("span", { class: "action-icon" }, "📋", -1),
                _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "action-title" }, "View Requests"),
                  _createElementVNode("div", { class: "action-desc" }, "Manage equipment requests")
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/inventory",
              class: "action-button"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createElementVNode("span", { class: "action-icon" }, "💻", -1),
                _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "action-title" }, "Manage Inventory"),
                  _createElementVNode("div", { class: "action-desc" }, "Add and track equipment")
                ], -1)
              ]))]),
              _: 1
            }),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('refresh'))),
              class: "action-button"
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("span", { class: "action-icon" }, "🔄", -1),
              _createElementVNode("div", null, [
                _createElementVNode("div", { class: "action-title" }, "Refresh Data"),
                _createElementVNode("div", { class: "action-desc" }, "Update dashboard stats")
              ], -1)
            ]))])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})